import { useTranslation } from 'react-i18next';
import { useBlocked, useConnection, useContacts, useConversationSummary, useLive, useServices, type ConversationSummary, type Id } from '@/model';
import { IconButton } from '@/ui';
import { useNavigation } from '@/app/contract';
import { callPath, newCallPath } from '@/app/paths';
import type { ChatAccessoryProps } from '@/features/chat/registry';
import { callRuntime } from '../call-runtime';
import { supportsCalls } from '../browser-media';
import { CallsHost } from './CallsHost';

export function canCall(summary:ConversationSummary|undefined,contacts:readonly Id[],blocks:readonly Id[]):boolean {
  if(!summary||summary.kind!=='direct'||summary.conversation.kind!=='direct'||summary.left||summary.conversation.me.left_seq!==null||summary.conversation.me.role==='viewer'||summary.conversation.can_send===false)return false;
  const peer=summary.peer;
  return !!peer&&peer.kind==='human'&&!peer.deleted&&contacts.includes(peer.id)&&!blocks.includes(peer.id)&&summary.conversation.members.filter(m=>m.left_seq===null).length===2;
}
export function CallHeaderActions({conversationId}:ChatAccessoryProps) {
  const {t}=useTranslation('calls'), services=useServices(),nav=useNavigation();
  const summary=useConversationSummary(conversationId),contacts=useContacts(),blocks=useBlocked(),connection=useConnection();
  const runtime=callRuntime(services),state=useLive(runtime.state),active=state.engine;
  const eligible=canCall(summary,contacts.map(c=>c.account.id),blocks);
  const start=(kind:'voice'|'video')=>{
    if(active&&!active.ended){runtime.focus();return;}
    if(!supportsCalls())nav.open(newCallPath(nav.section,{conversationId,kind}));
    else void runtime.start(conversationId,kind);
  };
  return <><CallsHost/>{eligible&&<div className="calls-header-actions">
    {active&&!active.ended?<IconButton name="phone.fill" label={t('action.returnToCall')} onClick={()=>runtime.focus()}/>:
      state.recovered[0]?<IconButton name="phone.fill" label={t('state.busy')} onClick={()=>nav.open(callPath(nav.section,state.recovered[0]!.id))}/>:<>
        <IconButton name="phone" label={t('action.voice')} disabled={connection.phase!=='online'} onClick={()=>start('voice')}/>
        <IconButton name="video" label={t('action.video')} disabled={connection.phase!=='online'} onClick={()=>start('video')}/>
      </>}
  </div>}</>;
}
